{
    "Valable jusqu’au": {
        "de": "Gültig bis",
        "en": "Valid until"
    },
    "Bon cadeau": {
        "de": "Geschenkgutschein",
        "en": "Gift voucher"
    },
    "Code de bon indisponible.": {
        "de": "Gutscheincode nicht verfügbar.",
        "en": "Voucher code unavailable."
    },
    "Ce bon n’est pas utilisable actuellement.": {
        "de": "Dieser Gutschein ist derzeit nicht einlösbar.",
        "en": "This voucher cannot currently be used."
    },
    "Ajoutez des places dans votre panier avant d’utiliser un bon.": {
        "de": "Legen Sie Plätze in den Warenkorb, bevor Sie einen Gutschein verwenden.",
        "en": "Add tickets to your basket before using a voucher."
    },
    "Ce panier n’est plus actif.": {
        "de": "Dieser Warenkorb ist nicht mehr aktiv.",
        "en": "This basket is no longer active."
    },
    "La commande est déjà ouverte ; reprenez son paiement ou attendez son expiration.": {
        "de": "Die Bestellung wurde bereits eröffnet. Setzen Sie die Zahlung fort oder warten Sie auf ihren Ablauf.",
        "en": "This order has already been opened. Resume its payment or wait for it to expire."
    },
    "Un panier accepte au plus dix bons.": {
        "de": "Ein Warenkorb akzeptiert höchstens zehn Gutscheine.",
        "en": "A basket accepts at most ten vouchers."
    },
    "Ce bon est déjà retenu pour votre panier.": {
        "de": "Dieser Gutschein ist bereits für Ihren Warenkorb reserviert.",
        "en": "This voucher is already reserved for your basket."
    },
    "Le montant dépasse le crédit disponible ou le total de votre panier.": {
        "de": "Der Betrag übersteigt das verfügbare Guthaben oder den Warenkorbwert.",
        "en": "The amount exceeds the available credit or your basket total."
    },
    "Le financement du bon doit être vérifié par la billetterie.": {
        "de": "Die Zahlung für den Gutschein muss von der Kasse geprüft werden.",
        "en": "The box office must verify payment for this voucher."
    },
    "Le financement du crédit doit être vérifié par la billetterie.": {
        "de": "Die Finanzierung des Guthabens muss von der Kasse geprüft werden.",
        "en": "The box office must verify the funding of this credit."
    },
    "Le montant ne respecte pas les limites configurées des bons cadeaux.": {
        "de": "Der Betrag liegt ausserhalb der festgelegten Gutscheinbeträge.",
        "en": "The amount is outside the configured gift voucher limits."
    },
    "Les conditions des bons ont changé. Rechargez et relisez-les avant de confirmer l’achat.": {
        "de": "Die Gutscheinbedingungen haben sich geändert. Laden Sie die Seite neu und lesen Sie sie vor dem Kauf.",
        "en": "The voucher terms have changed. Reload and review them before confirming the purchase."
    },
    "Cet achat a déjà été ouvert. Reprenez sa commande dans cet onglet ou retrouvez-le depuis votre espace spectateur.": {
        "de": "Dieser Kauf wurde bereits eröffnet. Setzen Sie die Bestellung in diesem Tab fort oder rufen Sie sie in Ihrem persönlichen Bereich auf.",
        "en": "This purchase has already been opened. Resume its order in this tab or retrieve it from your spectator account."
    },
    "La validité du bon est trop courte pour ce paiement en ligne. Choisissez la facture ou retirez ce bon.": {
        "de": "Die Gültigkeit des Gutscheins reicht für diese Onlinezahlung nicht aus. Wählen Sie Rechnung oder entfernen Sie den Gutschein.",
        "en": "The voucher expires too soon for this online payment. Choose invoice or remove this voucher."
    },
    "Le code de ce bon a été remplacé. La billetterie doit vérifier la commande avant sa reprise.": {
        "de": "Der Gutscheincode wurde ersetzt. Die Kasse muss die Bestellung vor der Fortsetzung prüfen.",
        "en": "This voucher code has been replaced. The box office must check the order before it can resume."
    },
    "La retenue du bon a expiré. La billetterie doit vérifier cette commande avant sa reprise.": {
        "de": "Die Gutscheinreservierung ist abgelaufen. Die Kasse muss diese Bestellung vor der Fortsetzung prüfen.",
        "en": "The voucher hold has expired. The box office must check this order before it can resume."
    },
    "Le solde du bon doit être vérifié avant de conclure cette commande.": {
        "de": "Das Gutscheinguthaben muss vor Abschluss dieser Bestellung geprüft werden.",
        "en": "The voucher balance must be checked before this order is completed."
    },
    "Le bon doit être financé et utilisable pour produire son document.": {
        "de": "Der Gutschein muss bezahlt und einlösbar sein, bevor sein Dokument erstellt wird.",
        "en": "The voucher must be paid and usable before its document can be produced."
    },
    "Le stockage des fichiers est momentanément indisponible. Le reste du théâtre fonctionne normalement ; réessayez dans un instant.": {
        "de": "Der Dateispeicher ist vorübergehend nicht verfügbar. Die übrigen Funktionen laufen normal; versuchen Sie es später erneut.",
        "en": "File storage is temporarily unavailable. Other venue functions are working normally; please try again shortly."
    },
    "Le document du bon nécessite une vérification par la billetterie. Le règlement et le solde restent enregistrés.": {
        "de": "Das Gutscheindokument muss von der Kasse geprüft werden. Zahlung und Guthaben bleiben gespeichert.",
        "en": "The box office must check the voucher document. The payment and balance remain recorded."
    },
    "Recevoir les nouvelles de cette maison (facultatif)": {
        "de": "Neuigkeiten dieses Hauses erhalten (optional)",
        "en": "Receive news from this venue (optional)"
    },
    "Bons cadeaux": {
        "de": "Geschenkgutscheine",
        "en": "Gift vouchers"
    },
    "Offrir un bon cadeau": {
        "de": "Einen Gutschein verschenken",
        "en": "Give a gift voucher"
    },
    "Acheter un bon": {
        "de": "Gutschein kaufen",
        "en": "Buy a voucher"
    },
    "La vente de bons cadeaux est fermée.": {
        "de": "Der Verkauf von Geschenkgutscheinen ist geschlossen.",
        "en": "Gift voucher sales are closed."
    },
    "Montant du bon (CHF)": {
        "de": "Gutscheinbetrag (CHF)",
        "en": "Voucher amount (CHF)"
    },
    "Offert par (facultatif)": {
        "de": "Geschenkt von (optional)",
        "en": "From (optional)"
    },
    "Message personnel (facultatif)": {
        "de": "Persönliche Nachricht (optional)",
        "en": "Personal message (optional)"
    },
    "Ce bon est utilisable en plusieurs fois dans cette maison. Il ne constitue pas un billet d’entrée.": {
        "de": "Dieser Gutschein ist in diesem Haus in mehreren Teilen einlösbar. Er ist keine Eintrittskarte.",
        "en": "This voucher can be used in parts at this venue. It is not an admission ticket."
    },
    "Activation après réception du règlement. Vous pourrez retrouver le bon dans votre espace spectateur.": {
        "de": "Aktivierung nach Zahlungseingang. Sie finden den Gutschein in Ihrem persönlichen Bereich.",
        "en": "Activated after payment is received. You can retrieve it from your spectator account."
    },
    "Consulter le solde d’un bon": {
        "de": "Guthaben eines Gutscheins abfragen",
        "en": "Check a voucher balance"
    },
    "Code du bon": {
        "de": "Gutscheincode",
        "en": "Voucher code"
    },
    "Consulter le solde": {
        "de": "Guthaben prüfen",
        "en": "Check balance"
    },
    "Crédit retenu pour votre panier": {
        "de": "Für Ihren Warenkorb reserviertes Guthaben",
        "en": "Credit reserved for your basket"
    },
    "Utiliser un bon ou un crédit": {
        "de": "Gutschein oder Guthaben verwenden",
        "en": "Use a voucher or credit"
    },
    "Appliquer le bon": {
        "de": "Gutschein anwenden",
        "en": "Apply voucher"
    },
    "Retirer ce bon": {
        "de": "Gutschein entfernen",
        "en": "Remove this voucher"
    },
    "Le code reste confidentiel. La retenue expire avec votre panier ; aucun crédit n’est débité avant la conclusion de la commande.": {
        "de": "Der Code bleibt vertraulich. Die Reservierung endet mit Ihrem Warenkorb. Das Guthaben wird erst beim Bestellabschluss belastet.",
        "en": "Keep the code confidential. The hold expires with your basket; credit is only debited when the order is completed."
    },
    "Reste à régler": {
        "de": "Noch zu bezahlen",
        "en": "Remaining to pay"
    },
    "Bon": {
        "de": "Gutschein",
        "en": "Voucher"
    },
    "Solde disponible": {
        "de": "Verfügbares Guthaben",
        "en": "Available balance"
    },
    "Télécharger mon bon cadeau (PDF)": {
        "de": "Meinen Geschenkgutschein herunterladen (PDF)",
        "en": "Download my gift voucher (PDF)"
    },
    "Le bon sera disponible après réception du règlement. Une facture ne l’active pas.": {
        "de": "Der Gutschein ist nach Zahlungseingang verfügbar. Eine Rechnung aktiviert ihn nicht.",
        "en": "The voucher will be available after payment is received. An invoice does not activate it."
    },
    "Mes bons et crédits": {
        "de": "Meine Gutscheine und Guthaben",
        "en": "My vouchers and credits"
    },
    "Aucun bon dans votre espace.": {
        "de": "Keine Gutscheine in Ihrem Bereich.",
        "en": "No vouchers in your account."
    },
    "Montant réglé par bons et crédits": {
        "de": "Mit Gutscheinen und Guthaben bezahlt",
        "en": "Paid with vouchers and credit"
    },
    "Commande entièrement réglée par crédit. Aucun paiement externe n’est demandé.": {
        "de": "Bestellung vollständig mit Guthaben bezahlt. Keine externe Zahlung erforderlich.",
        "en": "Order fully paid with credit. No external payment is requested."
    },
    "Valider la commande avec mes crédits": {
        "de": "Bestellung mit meinem Guthaben abschließen",
        "en": "Complete order with my credit"
    },
    "Sans date d’expiration": {
        "de": "Ohne Ablaufdatum",
        "en": "No expiry date"
    },
    "attente": {
        "de": "Zahlung ausstehend",
        "en": "Awaiting payment"
    },
    "actif": {
        "de": "Aktiv",
        "en": "Active"
    },
    "epuise": {
        "de": "Aufgebraucht",
        "en": "Used up"
    },
    "expire": {
        "de": "Abgelaufen",
        "en": "Expired"
    },
    "bloque": {
        "de": "Gesperrt",
        "en": "Blocked"
    },
    "termine": {
        "de": "Zurückgeführt",
        "en": "Returned to source"
    }
}
